<h1>Dashboard Edits: Bulk Name Update: {{ entityName | titlecase }}</h1>

<div class="table_action_header mt-3">
  <div class="table_action_header_left"></div>
  <div class="warning_message" *ngIf="data.entityType != 'creative'">
    You can update the names of the
    {{ entityName | titlecase }}s that are either ongoing or upcoming.
  </div>
  <div class="table_action_header_right"></div>
</div>

<div class="tableFixHead resizable-table">
  <table class="dashboard-update" mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef>
        <div class="table-checkboxes">
          <mat-checkbox
            #ref
            (change)="$event ? masterToggle() : null"
            [checked]="
              selection.hasValue() && isAllSelected() && isSomeSelected()
            "
            [indeterminate]="isSomeSelected() && !isAllSelected()"
          >
          </mat-checkbox>
        </div>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        [style.color]="row.color"
        [ngClass]="{ 'greyed-out': row.is_ended }"
      >
        <div class="table-checkboxes">
          <mat-checkbox
            [checked]="selection.isSelected(row)"
            (change)="$event ? selection.toggle(row) : null; isSomeSelected()"
          >
          </mat-checkbox>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef columnResize>
        <span class="table_header_name"> ID</span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        [ngClass]="{ 'greyed-out': row.is_ended }"
      >
        <span class="table_value_name"> {{ row.id }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef columnResize>
        <span class="table_header_name">Existing Name</span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        [ngClass]="{ 'greyed-out': row.is_ended }"
      >
        <span class="table_value_name">
          {{ row.name }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="new_name">
      <th mat-header-cell *matHeaderCellDef columnResize>
        <span class="table_header_name"> New Name</span>
      </th>
      <td
        mat-cell
        *matCellDef="let row; let index = index"
        [ngClass]="{ 'greyed-out': row.is_ended }"
      >
        <span
          class="table_value_name"
          [formGroup]="nameUpdateForm[index]"
          [matTooltip]="
            row.is_ended
              ? 'The ' +
                (entityName | titlecase) +
                ' has ended, so the name cannot be updated.'
              : ''
          "
        >
          <mat-form-field
            class="mt-2 mb-3"
            appearance="outline"
            floatLabel="always"
            [hideRequiredMarker]="false"
          >
            <mat-label>Name</mat-label>
            <input
              (keyup)="validate()"
              [(ngModel)]="row.new_name"
              required
              [maxLength]="255"
              style="height: auto"
              matInput
              type="text"
              autocomplete="off"
              placeholder="Enter name"
              formControlName="new_name"
              (ngModelChange)="onNameChange(row)"
            />
            <mat-error
              *ngIf="nameUpdateForm[index].hasError('required', 'new_name')"
            >
              Name is required
            </mat-error>
            <mat-error
              *ngIf="nameUpdateForm[index].hasError('overlapError', 'new_name')"
            >
              Name should be unique
            </mat-error>
          </mat-form-field>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="13">No data matching the filter</td>
    </tr>
  </table>
</div>

<div class="align-right genreport-btn mb-2">
  <button (click)="closeModal()" mat-button class="action_btn_no-border me-2">
    Cancel
  </button>
  <button
    (click)="deleteItems()"
    mat-button
    [hidden]="this.selection.selected.length == 0"
    [ngClass]="{ 'create-btn': true, 'me-2 mb-2': true }"
  >
    Delete
  </button>
  <button
    (click)="update()"
    mat-button
    [hidden]="this.data.selectedItems.length == 0"
    [disabled]="!isValid"
    [ngClass]="{
      'create-btn-disabled': !isValid,
      'create-btn': true,
      'me-2 mb-2': true
    }"
  >
    Save
  </button>
</div>
